<div class="side-nav-container" [class.open]="showSideNav">
  <div class="side-nav-content">
    <div class="side-nav-link-header flex items-center justify-start px-6">
      <button
        class="close-button focus-link p-0"
        [attr.aria-label]="'accessibility.title.close_slide_nav' | translate"
        (click)="closeSideNav()">
        <rd-shared-icon
          class="close-icon"
          [iconSymbol]="'icon-close'"
          [iconTheme]="'white'"></rd-shared-icon>
      </button>
    </div>
    <ng-container *ngIf="componentRenderState === 'loggedIn'">
      <button
        class="side-nav-points-balance focus-link flex w-full flex-col justify-center border-0 px-8"
        [ngClass]="{ 'menu-expanded': menuExpanded }"
        (click)="toggleMenu()"
        aria-controls="sidenav-submenu"
        [attr.aria-expanded]="menuExpanded ? 'true' : 'false'">
        <span class="typo-text-mobile">
          {{ 'wl.star.header.you_have_points' | translate }}
        </span>
        <strong
          class="typo-heading-20-bold"
          *ngIf="pointsSummary$ | async as pointsSummary">
          {{ pointsSummary.pointsBalance | localizePointsNumber }}
          {{ 'app.points' | translate }}
        </strong>

        <rd-shared-icon
          class="icon-chevron inline-flex transform transition duration-300"
          [iconSymbol]="'icon-chevron-down'"></rd-shared-icon>
      </button>
      <ul
        class="side-nav-user-profile my-0 px-2 py-1"
        [ngClass]="{
          'menu-expanded': menuExpanded,
          block: menuExpanded,
          hidden: !menuExpanded
        }"
        id="sidenav-submenu">
        <li class="side-nav-item px-4">
          <button
            [attr.aria-hidden]="menuExpanded ? 'false' : 'true'"
            class="side-nav-link focus-link"
            (click)="redirectToAndCloseSideNav('/points_activity')">
            {{ 'wl.star.header.points_activity' | translate }}
          </button>
        </li>
        <li class="side-nav-item px-4">
          <button
            [attr.aria-hidden]="menuExpanded ? 'false' : 'true'"
            class="side-nav-link focus-link"
            (click)="changePasswordEmit()">
            {{ 'wl.star.header.change_password' | translate }}
          </button>
        </li>
      </ul>
    </ng-container>
    <ul class="side-nav-list my-0 px-4 py-1">
      <li *ngFor="let navLink of starNavLinks" class="side-nav-item px-4">
        <a
          *ngIf="isExternalNavLink(navLink); else internalNavLink"
          [href]="navLink.route"
          target="_blank"
          rel="noreferrer"
          class="side-nav-link focus-link"
          (click)="closeSideNav()">
          {{ navLink.translationKey | translate }}
        </a>
        <ng-template #internalNavLink>
          <button
            class="side-nav-link focus-link"
            (click)="redirectToAndCloseSideNav(navLink.route)">
            {{ navLink.translationKey | translate }}
          </button>
        </ng-template>
      </li>
      <li
        *ngIf="componentRenderState === 'loggedIn'"
        class="side-nav-item px-4">
        <button class="side-nav-link focus-link" (click)="logoutEmit()">
          <rd-shared-icon
            class="logout-icon"
            [iconSymbol]="'icon-logout'"></rd-shared-icon>
          <span class="pl-2"> {{ 'wl.star.header.log_out' | translate }} </span>
        </button>
      </li>
      <li *ngIf="componentRenderState === 'loggedOut'">
        <rd-shared-button
          class="login-button"
          (clickFn)="loginEmit()"
          [buttonClass]="'login-button'"
          [buttonContent]="loginButtonContent"
          [buttonTheme]="'primary'">
          <ng-template #loginButtonContent>
            <div class="button-content">
              <span>{{ 'wl.star.header.log_in' | translate }}</span>
            </div>
          </ng-template>
        </rd-shared-button>
      </li>
      <li *ngIf="componentRenderState === 'loggedOut'" class="pt-4">
        <rd-shared-button
          class="enroll-button"
          (clickFn)="enrollEmit()"
          [buttonClass]="'login-button'"
          [buttonContent]="enrollButtonContent"
          [buttonTheme]="'outline-primary'">
          <ng-template #enrollButtonContent>
            <div class="button-content">
              <span>{{ 'wl.star.header.enroll_now' | translate }}</span>
            </div>
          </ng-template>
        </rd-shared-button>
      </li>
    </ul>
  </div>
</div>
